export default __webpack_public_path__ + "static/media/codeJunkieLogo.cd281a68.png";